<!--ptw总包与分包分类-->
<template>
  <div style="width: 100%; height: 100%; position: absolute; color: white">
    <h1
      style="width: 100%; height: 70px; position: absolute; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      {{ title }}
    </h1>
    <div v-if="showLoading" key="1" class="injuryDiv"
         style="width: 100%; height: 793px; position: absolute; bottom: 0">
      <div class="container1" style="height: 100%;"></div>
    </div>
    <div v-else-if="dataNotNull" key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; color: white">
      <div class="injury_title" @click="showDetail">1. Workplace Injury Rate</div>
      <div class="injury_title content one" @click="showDetail">{{ work_rate }}</div>
      <div class="injury_title two" @click="showDetail2">2. Accident Frequency Rate(AFR)</div>
      <div class="injury_title content three" @click="showDetail2">{{ accident_rate }}</div>
      <div class="injury_title four" @click="showDetail2">3. Accident Severity Rate(ASR)</div>
      <div class="injury_title content five" @click="showDetail2">{{ severity_rate }}</div>
    </div>
    <div v-else key="3"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
    <div class="injury_detail" v-show="showflag">
      <h1
        style="width: 100%; height: 70px; position: absolute; color: #333; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
        Workplace Injury Rate
      </h1>
      <div class="close_img_gentry" @click="detailClose"></div>
      <div class="injury_inner">
        <div class="injury_top">
          <div class="top_left">
            <div class="left_top">0</div>
            <div class="left_bottom">No. of Fatal</div>
          </div>
          <div class="top_left">
            <div class="left_top" @click="showSecond">{{ no_fatal_count }}</div>
            <div class="left_bottom">No. of Non-fatal</div>
          </div>
        </div>
        <div class="injury_bottom">
          <div class="left_top">{{ staff_count }}</div>
          <div class="left_bottom">No. of Employed Persons</div>
        </div>
      </div>
    </div>

    <div class="injury_detail1" v-show="showflag1" id="daily_tbm_detail1">
      <p style="margin-top: 20px; margin-left: 20px; text-align: left">Non-Fatal Injuries(Incident)</p>
      <div class="close_img_gentry" @click="detail1Close"></div>
      <div class="injuryDiv1" style="margin-top:40px; width: 100%; height: 540px">
        <div class="container1" style="height: 100%"></div>
      </div>
    </div>
    <div class="injury_detail" v-show="showflag2" id="daily_tbm_detail2">
      <p style="margin-top: 20px; margin-left: 20px; text-align: left">Accident</p>
      <div class="close_img_gentry" @click="detail2Close"></div>
      <div class="injuryDiv2" style="margin-top:40px; width: 100%; height: 540px">
        <div class="container1" style="height: 100%"></div>
      </div>
    </div>
    <div class="injury_detail3" v-if="detail3_data.length > 0" v-show="showflag3" id="daily_tbm_detail3">
      <div class="top_container">
        <div class="top_1"></div>
        <div class="top_1"></div>
        <div class="top_1">{{ date_index + 1 }} of {{ detail3_data.length }}</div>
        <div class="close_img_training" @click="detail3Close"></div>
      </div>
      <div class="top_container time_container">
        <div class="time_left" v-show="date_index > 0" @click="showPre"></div>
        <div class="time_left left_nomore" v-show="date_index == 0"></div>
        <div class="time_time">{{ detail3_data[date_index].date }}</div>
        <div class="time_right" v-show="date_index + 1 < detail3_data.length" @click="showNext"></div>
        <div class="time_right right_nomore" v-show="date_index + 1 == detail3_data.length"></div>
      </div>
      <div class="top_container content_container">
        <div class="content_sn">S/N</div>
        <div class="content_p">Name</div>
        <div class="content_d">Medical Leave(Days)</div>
      </div>
      <div class="list_container">
        <div class="top_container content_container list_content"
             v-for="(item, index) in detail3_data[date_index].list">
          <div class="content_sn list_one">{{ index + 1 }}</div>
          <div class="content_p list_one">{{ item.name }}</div>
          <div class="content_d list_one">{{ item.leave }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import echarts from "echarts";

export default {
  props: ['project_id', 'total_manhour'],
  name: "injury_record",
  data() {
    return {
      my_project_id: this.project_id,
      name: "injury_record",
      dataNotNull: true,
      color: this.$store.state.color.chart_color,
      title_data: 'Injury Record',
      title_nodata: 'Injury Record',
      title: 'Injury Record',
      myChart: null,
      myChart1: null,
      myChart2: null,
      showLoading: true,
      work_rate: 0,
      accident_rate: 0,
      severity_rate: 0,
      fatal_count: 0,
      no_fatal_count: 0,
      staff_count: 0,
      showflag: false,
      showflag1: false,
      showflag2: false,
      showflag3: false,
      date_index: 0,
      detail3_data: [],
    }
  },
  methods: {
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    showNext() {
      this.date_index += 1
    },
    showPre() {
      this.date_index -= 1
    },
    showDetail() {
      this.showflag = true
    },
    showDetail2() {
      let that = this
      that.showflag2 = true
      let postData = {
        project_id: this.my_project_id,
        start_date: this.getNowFormatDate(),
        end_date: this.getNowFormatDate(),
        user: window.localStorage.getItem("token_key"),
        // token: window.localStorage.getItem('token')
        token: "lalala"
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjInjuryCon", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        var legends = []
        var datas = []
        this.myChart.hideLoading()
        this.showLoading = false
        if (errNo == "0") {
          var result = resp.data.result;
          for (let i in result) {
            let con_name = result[i].short_name
            let index = legends.indexOf(con_name)
            if (index > -1) {
              datas[index].value += 1
            } else {
              datas.push({name: con_name, value: 1})
              legends.push(con_name)
            }
          }
          that.$nextTick(() => {
            if (!this.myChart2) {
              this.myChart2 = echarts.init(document.querySelector('.injuryDiv2 .container1'))
              this.myChart2.setOption({
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'none'
                  },
                  formatter: function (params) {
                    return params[0].data.name + ':  ' + params[0].data.value;
                  },
                  textStyle: {
                    fontSize: '40'
                  }
                },
                grid: {
                  left: 220
                },
                xAxis: {
                  type: 'value',
                  show: false,
                  axisLabel: {
                    formatter: '{value}'
                  }
                },
                yAxis: {
                  type: 'category',
                  inverse: true,
                  data: legends,
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: '#6CF'
                    }
                  },
                  axisTick: {
                    show: false
                  },
                  axisLabel: {
                    margin: 15,
                    show: true,
                    textStyle: {
                      color: '#333',
                      fontSize: 22
                    }
                  },
                  splitLine: {
                    show: false
                  }
                },
                series: [
                  {
                    name: '总计',
                    type: 'bar',
                    barWidth: '60%',
                    label: {
                      normal: {
                        show: true,
                        color: '#6cf',
                        position: 'right',
                        fontSize: '25',
                        formatter: function (params) {
                          return params.value
                        }
                      }
                    },
                    itemStyle: {
                      normal: {
                        color: function (params) {
                          return that.color[params.dataIndex]
                        },
                        borderColor: '#999',
                        borderWidth: '0',
                      }
                    },
                    data: []
                  },
                ]
              })
              this.myChart2.on('click', function (param) {
                that.showFourth(param.data.name)
              });
              var data = {
                ptws: datas,
              }
              this.myChart2.setOption({
                series: [
                  {
                    data: data.ptws
                  }
                ]
              })
            }
          })
        }
      })

    },
    showDetail3() {
      var that = this
      this.showflag3 = true
    },
    detailClose() {
      this.showflag = false
      this.showflag1 = false
      this.showflag2 = false
      this.showflag3 = false
    },
    detail1Close() {
      this.showflag1 = false
    },
    detail2Close() {
      this.showflag2 = false
      this.showflag3 = false
      this.detail3_data = []
    },
    detail3Close() {
      this.showflag3 = false
      this.detail3_data = []
    },
    showSecond() {
      let that = this
      that.showflag1 = true
      let postData = {
        project_id: this.my_project_id,
        start_date: this.getNowFormatDate(),
        end_date: this.getNowFormatDate(),
        user: window.localStorage.getItem("token_key"),
        // token: window.localStorage.getItem('token')
        token: "lalala"
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjInjuryCon", postData).then(resp => {
          var errNo = resp.data.errno
          var errStr = resp.data.errstr_cn
          var legends = []
          var datas = []
          this.myChart.hideLoading()
          this.showLoading = false
          if (errNo == "0") {
            var result = resp.data.result;
            for (let i in result) {
              let con_name = result[i].short_name
              let index = legends.indexOf(con_name)
              if (index > -1) {
                datas[index].value += 1
              } else {
                datas.push({name: con_name, value: 1})
                legends.push(con_name)
              }
            }
            that.$nextTick(() => {
              if (!this.myChart1) {
                this.myChart1 = echarts.init(document.querySelector('.injuryDiv1 .container1'))
                this.myChart1.setOption({
                  tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                      type: 'none'
                    },
                    formatter: function (params) {
                      return params[0].data.name + ':  ' + params[0].data.value;
                    },
                    textStyle: {
                      fontSize: '40'
                    }
                  },
                  grid: {
                    left: 220
                  },
                  xAxis: {
                    type: 'value',
                    show: false,
                    axisLabel: {
                      formatter: '{c}'
                    }
                  },
                  yAxis: {
                    type: 'category',
                    inverse: true,
                    data: legends,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        color: '#6CF'
                      }
                    },
                    axisTick: {
                      show: false
                    },
                    axisLabel: {
                      margin: 15,
                      show: true,
                      textStyle: {
                        color: '#333',
                        fontSize: 22
                      }
                    },
                    splitLine: {
                      show: false
                    }
                  },
                  series: [
                    {
                      name: '总计',
                      type: 'bar',
                      barWidth: '60%',
                      label: {
                        normal: {
                          show: true,
                          color: '#6cf',
                          position: 'right',
                          fontSize: '25',
                          formatter: function (params) {
                            return params.value
                          }
                        }
                      },
                      itemStyle: {
                        normal: {
                          color: function (params) {
                            return that.color[params.dataIndex]
                          },
                          borderColor: '#999',
                          borderWidth: '0',
                        }
                      },
                      data: datas,
                    },

                  ]
                })
                this.myChart1.on('click', function (param) {
                  that.showFourth(param.data.name)
                });
              }
            })
          } else {
            alert(errStr)
          }
        }
      ).catch(error => {
        this.myChart.hideLoading()
        this.showLoading = false
        this.dataNotNull = false
        this.title = this.title_nodata
        alert(error)
      })

    },
    showFourth(name) {
      var that = this
      this.showflag3 = true
      let postData = {
        project_id: this.my_project_id,
        con_name: name,
        start_date: this.getNowFormatDate(),
        end_date: this.getNowFormatDate(),
        user: window.localStorage.getItem("token_key"),
        // token: window.localStorage.getItem('token')
        token: "lalala"
      }
      var legends = []
      var datas = []
      axios.post(this.$store.getters.getCmsServer + "DBProjInjuryConDetail", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        if (errNo == "0") {
          var result = resp.data.result;
          for (let i in result) {
            let index = legends.indexOf(result[i].date)
            if (index >= 0) {
              datas[index].list.push(
                {
                  name: result[i].user_name,
                  leave: result[i].sick_leave_days
                }
              )
            } else {
              legends.push(result[i].date)
              datas.push({
                date: result[i].date,
                list: [
                  {
                    name: result[i].user_name,
                    leave: result[i].sick_leave_days
                  }
                ]
              })
            }
          }
        }
      })
      this.detail3_data = datas
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
    if (this.myChart1) {
      this.myChart1.clear()
    }
    if (this.myChart2) {
      this.myChart2.clear()
    }
  },
  mounted() {
    let that = this
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.myChart = echarts.init(document.querySelector('.injuryDiv .container1'))
    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });
  },
  watch: {
    total_manhour(val) {
      var that = this
      this.total_manhour = val
      let postData = {
        project_id: this.my_project_id,
        start_date: this.getNowFormatDate(),
        end_date: this.getNowFormatDate(),
        user: window.localStorage.getItem("token_key"),
        // token: window.localStorage.getItem('token')
        token: "lalala"
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjInjury", postData).then(resp => {
          var errNo = resp.data.errno
          var errStr = resp.data.errstr_cn
          this.myChart.hideLoading()
          this.showLoading = false
          if (errNo == "0") {
            var result = resp.data.result;
            that.work_rate = (parseInt(result[0].nofatalcount) / parseInt(result[0].staff_count) * 100000).toFixed(2);
            that.no_fatal_count = result[0].nofatalcount
            that.staff_count = result[0].staff_count
            that.accident_rate = (parseInt(result[0].nofatalcount) / parseInt(that.total_manhour) * 1000000).toFixed(2);
            that.severity_rate = (parseInt(result[0].leave_count) * 8 / parseInt(that.total_manhour) * 1000000).toFixed(2);
          } else {
            alert(errStr)
          }
        }
      ).catch(error => {
        this.myChart.hideLoading()
        this.showLoading = false
        this.dataNotNull = false
        this.title = this.title_nodata
        alert(error)
      })
    },
  }
}
</script>


<style lang="stylus" rel="stylesheet/stylus">

.injury_title {
  width: calc(100% - 20px)
  padding-left 20px
  height 100px
  top 50px
  position: absolute;
  font-size 60px
  text-align left
}

.content {
  text-align center
  font-size 100px
  height 120px
}

.one {
  top 150px
}

.two {
  top 300px
}

.three {
  top 400px
}

.four {
  top 550px
}

.five {
  top 650px
}

.injury_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 90%;
  height: 80%;
  left: 5%;
  top: 12%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  color #333333
}

.injury_detail1 {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 80%;
  height: 70%;
  left: 10%;
  top: 16%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  color #333333
  box-shadow: inset 0px 0px 5px 1px #66CCFF;
}

.injury_detail3 {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  box-shadow: inset 0px 0px 5px 1px #66CCFF;
  position: absolute;
  width: 80%;
  height: 70%;
  left: 10%;
  top: 17%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  color #333333
  display flex
  flex-direction column
}

.injury_inner {
  display flex
  flex-direction column
  width 100%
  margin-top: 120px;
  width: 100%;
  height: 540px;
  overflow scroll
}

.injury_top {
  display flex
  height 50%
  width 100%
}

.top_left {
  width 50%;
  height 100%;
  display flex
  flex-direction column
}

.left_top {
  width 100%;
  height 75%
  line-height 200px
  font-size 120px
  font-weight bold
}

.left_bottom {
  width 100%;
  height 25%
  font-size 36px
  font-weight bold
  line-height 60px
}

.injury_bottom {
  display flex
  flex-direction column
  height 50%
  width 100%
}
</style>




// WEBPACK FOOTER //
// src/components/safety_manage/injury_record.vue